import { motion } from 'framer-motion';
import styled, { css } from 'styled-components';

import DesktopOffices, {
  DesktopOfficesProps,
} from 'components/DesktopOffices/DesktopOffices';
import MobileOfficesAccordion, {
  MobileOfficesAccordionProps,
} from 'components/MobileOfficesAccordion/MobileOfficesAccordion';
import { setVh } from 'utils/styles/mixins';
import { mediaDesktop } from 'utils/styles/responsive';

const defaultColumns = css`
  grid-column: main-section / out-right;
`;

export const Wrapper = styled(motion.div)`
  width: 100%;
  height: 100%;
  min-width: 100vw;
  min-height: ${setVh(100)};

  padding: 101px 0 80px;

  display: grid;
  grid-template-columns: [out-left] 16px [main-section] auto [out-right] 16px;

  ${mediaDesktop(`
    padding: 52px 0 101px;
    grid-template-columns: [out-left] 92px [main-section] auto [out-right] 92px;
    grid-column-gap: 32px;
  `)}
`;

export const MobileOfficesAccordionContactPage = styled(
  MobileOfficesAccordion
)<MobileOfficesAccordionProps>`
  ${defaultColumns};
`;

export const DesktopOfficesContactPage = styled(
  DesktopOffices
)<DesktopOfficesProps>`
  ${defaultColumns};
`;
